import { CLASS_IDS, classOf, PALETTE } from "@eldrun/content";
import { gameColor } from "../render/style/roles.ts";
import { badge, bar, button, divider, field, icon, iconButton, panel, pips, section, select, slider, slot, statRow, stepper, tabs, toggle } from "../ui/kit/components.ts";
import { h } from "../ui/kit/dom.ts";
import { applyTheme, KIT_ICONS } from "../ui/kit/kit-model.ts";

/** Uma coluna da vitrine com todos os componentes, num tema (o neutro ou o de um slot). */
function column(title: string, accent: string | undefined): HTMLElement {
  const menu = h(
    "div",
    { class: "k-vitrine-menu" },
    button({ label: "Jogar", icon: "icone-jogar", variant: "menu" }),
    button({ label: "Continuar", icon: "icone-continuar", variant: "menu" }),
    button({ label: "Multijogador", icon: "icone-multijogador", variant: "menu" }),
    button({ label: "Opções", icon: "icone-opcoes", variant: "menu" }),
    button({ label: "Sair", icon: "icone-sair", variant: "menu" }),
  );
  const hud = h(
    "div",
    { class: "k-vitrine-linha" },
    iconButton({ icon: "hud-opcoes", label: "Opções" }),
    iconButton({ icon: "hud-mochila", label: "Mochila" }),
    iconButton({ icon: "hud-mapa", label: "Mapa" }),
    iconButton({ icon: "hud-pausa", label: "Pausa" }),
    badge("Comum"),
    badge("Empilhável"),
    pips(2, 5),
  );
  const tabBar = tabs(
    [
      { id: "graficos", label: "Gráficos", icon: "icone-tela" },
      { id: "audio", label: "Áudio", icon: "icone-som" },
      { id: "controles", label: "Controles", icon: "icone-controle" },
    ],
    () => {},
  );
  const grid = h(
    "div",
    { class: "k-vitrine-grade" },
    slot({ label: "Machado", icon: "categoria-ferramentas", tier: 2, key: "1" }),
    slot({ label: "Lança", icon: "categoria-armas", tier: 3, key: "2", selected: true }),
    slot({ label: "Carne assada", icon: "categoria-consumiveis", qty: 3, key: "3" }),
    slot({ label: "Madeira", icon: "categoria-materiais", qty: 40, key: "4" }),
    slot({ label: "vazio" }),
    slot({ label: "vazio" }),
  );
  const options = section(
    "Tela",
    true,
    field("Modo", select({ label: "Modo", options: [{ value: "tela-cheia", label: "Tela cheia" }, { value: "janela", label: "Janela" }], value: "tela-cheia" })),
    field("Sincronia vertical", stepper({ label: "Sincronia vertical", options: ["Desligada", "Ligada"], index: 1 })),
    field("Mostrar FPS", toggle({ label: "Mostrar FPS", checked: true })),
    field("Desfoque", toggle({ label: "Desfoque" })),
    field("Brilho", slider({ label: "Brilho", min: 0, max: 100, value: 50 })),
  );
  const detail = panel(
    { title: "Inventário", icon: "icone-inventario", onClose: () => {} },
    tabBar.element,
    grid,
    divider(),
    bar({ label: "Vida", icon: "vital-vida", value: 82, max: 100 }),
    bar({ label: "Fôlego", icon: "vital-folego", value: 40, max: 100 }),
    bar({ label: "Peso", value: 123.4, max: 250, text: "123,4 / 250,0" }),
    statRow("icone-salvar", "Peso", "0,0"),
    statRow("aba-habilidades", "Nível", pips(3, 5)),
    divider(),
    options,
    h(
      "div",
      { class: "k-vitrine-linha" },
      button({ label: "Mover", icon: "icone-chevron", variant: "acao" }),
      button({ label: "Usar", icon: "icone-jogar", variant: "acao" }),
    ),
    h(
      "div",
      { class: "k-vitrine-linha" },
      button({ label: "Voltar", icon: "icone-voltar", variant: "secundario" }),
      button({ label: "Restaurar", icon: "icone-restaurar", variant: "secundario" }),
      button({ label: "Aplicar", icon: "icone-confirmar", variant: "primario" }),
    ),
  );
  const gallery = h("div", { class: "k-vitrine-icones" }, ...KIT_ICONS.map((name) => h("span", { title: name }, icon(name))));
  const el = h("section", { class: "k-vitrine-coluna", "aria-label": title }, h("h2", { class: "k-vitrine-tema" }, title), h("div", { class: "k-vitrine-lado" }, h("div", {}, menu, hud, gallery), detail));
  applyTheme(el, accent);
  return el;
}

/**
 * Vitrine do kit (`?debug=ui&painel=kit&slot=0..3`, F79): todos os componentes no tema neutro e no da
 * classe de índice pedido (F85), lado a lado, para comparar com os mockups da Fase 9.
 */
export function startKitShowcase(parent: HTMLElement, slot: number): void {
  const c = classOf(CLASS_IDS[Math.max(0, slot)] ?? "");
  const accent = gameColor(PALETTE.classes[c.id].hex);
  parent.append(h("main", { class: "k-vitrine" }, column("Tema neutro", undefined), column(`Tema da classe ${c.name}`, accent)));
}
